//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            dataList: [],
        }
    },
    methods: {
        getRecommend() {
            let that = this;
            let searchItem = {
                currentPage: 1,
                pageSize: 20,
                isSuit: 0
            }
            that.$axios.get('/api/v1.0/familyApp/goods', {
                params: searchItem
            }).then(function (response) {
                if(response.status == 200) {
                    var storeGoodsList = response.body.storeGoodsList.map((item) => {
                        item.poster = item.photo;
                        item.goodsName = item.goodsTitle;
                        return item;
                    });
                    that.dataList = storeGoodsList;
                } else if(response.status == 203) {

                }
            })
        },
        // 打开商品详情
        toDetail(item) {
            this.$router.push('/mallGoodsDetail?backPath=' + this.$route.path + '&goodsId=' + item.goodsId);
        },
        submit(type_, goods) {
            if (!sessionStorage.token) {
                this.$store.state.APPPAGE.toLoginFunc();
                return false;
            }
            if (type_ == 1) {
                let that = this;
                let orderCart = {
                    goodsId: goods.goodsId,
                    goodsAttributeId: goods.goodsAttributeId,
                    number: 1
                };
                let data = {
                    orderCart: JSON.stringify(orderCart),
                    shopperId: that.$store.state.userInfo.shopperId
                };
                that.$axios.post('/api/v1.0/lonbonShop/saveOrderCart', that.qs.stringify(data)).then(function(response) {
                    if (response.status == 200) {
                        that.$vux.toast.show({
                            text: '已加入购物车',
                            type: 'success'
                        });
                        that.$store.state.APPPAGE.getOrderCartNum();
                        that.$emit("updateShoppingCart", goods)
                    }
                });
                
            } else {
                goods.number = 1;
                sessionStorage.readyBuyGoods = JSON.stringify([goods]);
                this.$router.push('/settlement');
            }
        }
    },
    mounted() {
        this.getRecommend();
    }
}



// WEBPACK FOOTER //
// ./src/pcComponents/shoppingCart/recommend.vue